(function (aimi_business_profile, $, app, undefined) {
  // Private object to hold module internals.
  let __this = {};

  /**
   * Stores business profile settings, initially empty and to be populated dynamically.
   */
  __this.business_profiles = {};

  /**
   * Cached jQuery selector for the document's body.
   */
  __this.$body = $('body');

  /**
   * Represents a list of business profiles, extending functionality from a generic table list.
   * This class is responsible for rendering business profiles into a specific format within a given container.
   * It handles dynamic data loading, parsing, and presentation of business profiles with custom logic for processing and displaying graphical elements such as logos and headshots.
   *
   * @extends TableList
   */
  class BusinessProfileList extends TableList {
    /**
     * Constructs an instance of the BusinessProfileList class.
     *
     * @param {Object} app - The main application object, used for accessing global templates, configurations, and APIs.
     * @param {jQuery} container - The jQuery object representing the DOM container where the business profile list will be rendered.
     * @param {string} listRow - The identifier for the row template to be used when rendering each business profile.
     * @param {string} [searchInputId='searchTable'] - Optional. The ID of the search input element. Defaults to 'searchTable' if not provided.
     */
    constructor(app, container, listRow, searchInputId = 'searchTable') {
      super(app, container, listRow, searchInputId);
      this.container.empty();
    }

    /**
     * Prepares and returns a jQuery object representing a single row in the business profile list.
     * This method parses and formats the business profile data, applying templates and initiating any necessary observers for image loading.
     *
     * @param {Object} row - The raw data object for a single business profile, as retrieved from the API.
     * @returns {jQuery} A jQuery object that represents the fully prepared and formatted row for insertion into the DOM.
     */
    prepareRow(row) {
      const page = _.template(this.app.templates[this.listRow]);
      let graphics;

      if (!app.isEmpty(row) && !app.isEmpty(row.config)) {
        row.config = JSON.parse(row.config);
        graphics = row.config.graphics || {};
      }

      let pageData = {
        ...row,
        'headshot': '',
        'logo': '',
        'statusClass': 'badge badge-secondary',
        'date_created': moment(moment.utc(row.date_created).toDate()).format('ll'),
      };

      if (row.status === 'complete') {
        pageData.statusClass = 'badge badge-success';
      }

      if (row.status === 'incomplete') {
        pageData.statusClass = 'badge badge-warning';
      }

      // Graphics Logo and headshot
      if (!app.isEmpty(graphics) && !app.isEmpty(graphics.headshot)) {
        pageData.headshot = graphics.headshot.thumb;
      }

      // Graphics Logo and headshot
      if (!app.isEmpty(graphics) && !app.isEmpty(graphics.image)) {
        pageData.logo = graphics.image.thumb;
      }

      const calendars = [{
        id : null, name : this.staticPH
      }];

      pageData.calendars = calendars;
      const $page = $(page(pageData));

      let $images = $('[data-type="image"]', $page);
      $images.each(function (index, image) {
        if ($(image).attr('data-src') !== '') {
          __this.observerManager.observeIntersection(image);
        }
      });
      return $page;
    }

    loaderData = {
      id: null,
      name: this.staticPH,
      headshot: '',
      logo: '',
      calendars : '',
      status: this.staticPH,
      statusClass: '',
      date_created: this.staticPH
    }


    /**
     * Initiates the rendering process for the business profile list.
     * This method fetches the list of business profiles from the API, processes each through `prepareRow`, and then appends them to the container.
     * It handles loading states and updates the UI accordingly.
     *
     * @returns {jQuery.Promise} A promise that resolves when the list has been fully rendered.
     */
    async renderList() {

      const $listContainer = this.container.empty();
      this.showLoader(this.loaderData);

      const response = await  this.app.apis['business_profile'].list();
      this.removeLoader();
      if (response.data && response.data.length) {
        _.each(response.data, (row) => {
          __this.business_profiles[row.id] = row;
          let $row = this.prepareRow(row);
          $row.appendTo($listContainer);
        });
      }
      app.localStorage.setItem('businessProfiles', JSON.stringify(__this.business_profiles));

      // Set calendar names
      const calendars = await app.apis['calendar'].fetch();
      const $rows = $(`.business-profile-row`);
      _.each($rows, function (row) {
        const $row = $(row).find(`.associated-calendars`);
        $row.empty();
      })

      if(!app.isEmpty(calendars)) {
        _.each(calendars, function (calendar) {
          const $row = $(`.business-profile-row[data-id=${calendar.persona_id}] .associated-calendars`);
          const $a = $(`<a href="/calendar/${calendar.id}" class="calendar-link btn btn-sm btn-outline-secondary me-2 " data-id="${calendar.id}">${calendar.name}</a>`);
          $row.append($a);
        });
      }
    }
  }

  /**
   * List
   */
  aimi_business_profile.list = {
    listRow: 'business_profile__list-row',
    init: function () {

      const $listContainer = $('[data-business-profiles]');

      __this.listMananger = new BusinessProfileList(app, $listContainer, this.listRow, 'searchTable');

      __this.listMananger.renderList();

      __this.observerManager = new ImageObserverManager(app, $('.row-image-wrapper', $listContainer).eq(0), 'calendar-card-width');

      // To observe resizing for an element
      __this.observerManager.observeResize($listContainer[0]);

      /**
       * Adjusts card width after waiting for body animations to complete.
       */
      setTimeout(function () {
        __this.observerManager.setCardWidth();
      }, 500);

      /**
       * Handles click events on the delete button of each business profile list item.
       * Confirms the delete action with the user before proceeding.
       */
      $(document).off('click.aimi_business_list_delete').on('click.aimi_business_list_delete', 'tr:not(.pre-loader) .btn-delete', function (e) {
        let id = $(this).data('id');
        app.confirm("Delete Business Profile?", "Are you sure you want to delete this Business Profile?").then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            app.apis['business_profile'].delete(id).done(function (response) {
              if (response.success !== true) {
                let calendars = _.pluck(response.calendars, 'name').join('<br/>');
                const message = `
                  <div class="business-profile-not-deletable text-start">
                    You cannot delete a business profile that is currently assigned to an active calendar.
                    <br/><br/>
                    Your business profile is currently assigned to the following calendars:
                    <br/><br/>
                    <b>${calendars}</b>
                    <br/><br/>
                    To delete this business profile, please do one of the following:
                    <br/><br/>
                    1. Delete the calendars currently assigned to this business profile before trying to delete this business profile.
                    <br/><br/>
                    2. Change the business profile assigned to the calendars above to a different one than the one you are trying to delete.
                  </div>
                  `;

                app.infoModal('Not Deleted', message);
              } else {
                // Render list if deleted
                __this.listMananger.renderList();
              }
              app.doButtonReset($button);
              app.hideModal($modal);
            }).fail(function (response) {
              app.doButtonReset($button, false);
              app.hideModal($modal);
            });
          }
        });
      });

      new SimpleBar(document.getElementById('tab_block_1'), {autoHide: true});
    }
  }
}(window.aimi_business_profile = window.aimi_business_profile || {}, jQuery, PreBuilt));